<script setup lang="ts">
import type { AssociatedCompany } from '~/config'

interface Props {
  company: AssociatedCompany
}
const props = defineProps<Props>()

const id = computed(() => (props.company.code ? [`${props.company.code}-logo`] : []))
const { allCompleted: isReady } = useImageLoaderTracker(id)
</script>

<template>
  <PvSkeleton
    v-if="!isReady"
    class="aspect-[17/9] w-full"
  />
  <ClientOnly>
    <CardComponent v-show="isReady">
      <ImageComponent
        :id
        :src="getCompanyLogo(company?.logoWhiteUrl)"
        class="aspect-[17/9] rounded-md object-cover invert"
      />
    </CardComponent>
  </ClientOnly>
</template>
